import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.querySelectorAll('img[loading="lazy"]:not([width])').forEach(this.#eagerLoadUnsizedImage);
  }

  /**
   * Images pasted into the RTE (e.g. migrated from Webflow) come with
   * loading="lazy" but no width/height. With `width: auto` in CSS such an
   * image is 0×0 until it loads, and Chrome never starts loading a lazy
   * image that has no box — so it stays blank forever. Loading it eagerly
   * is the only reliable fix without knowing its dimensions server-side.
   * @param {HTMLImageElement} img
   */
  #eagerLoadUnsizedImage(img) {
    img.loading = 'eager';
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
